// extracted by mini-css-extract-plugin
export default {"container":"FormDetails_container__rCMwo","loadingContainer":"FormDetails_loadingContainer__n6dOc"};